<template>
    <div class="right_bottom">
        <div class="right_input">
            <el-input
                class="input_textarea hide-scrollbar"
                type="textarea"
                autosize
                resize='none'
                rows="5"
                placeholder="请输入您想了解的内容，按Shift+Enter换行"
                v-model="inputValue" @keyup.enter.prevent.native="pdfSendMessage">
            </el-input>
            <div class="send_btn flex items-center justify-center">
                <el-button :plain="true" v-if="isFetching" class="waitBtn animate-spin cursor-pointer el-icon-refresh-right text-[20px] text-[#fff] bg-none"></el-button>
                <div class="h-full" v-else>
                    <el-button class="w-full h-full !px-[29px] !py-[17px] !border-0 !p-0 !bg-none !text-white" @click="pdfSendMessage">发布</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['qaType','isFetching'],
    data() {
        return {
            inputValue: '',
        }
    },
	created(){
		// this.$bus.$on('pdfChatSendEnd',()=>{
		// 	this.isFetching = false
		// })
		this.$bus.$on('recommendedQuestion',(val)=>{
			this.inputValue = val?.trim()
		})
	},
    methods: {
		pdfSendMessage() {
			if (this.inputValue.trim() == ''){
				return this.$message({
					message: '请输入问题',
					type: 'warning',
					center: true
				});
			}
			// this.$bus.$emit('pdfFetching', false)
			this.$bus.$emit('pdfSendMessage', this.inputValue)
            // this.isFetching = false
			this.inputValue = ''
			this.$emit('send')
		}
    }
}
</script>

<style lang="scss" scoped>
.right_bottom{
    @apply px-8 py-4 bg-white;
    .right_input{
        @apply  flex flex-row items-end justify-between ;
        .input_textarea {
            @apply max-h-[115px] min-h-[20px] flex-1 overflow-y-auto bg-[#FAF9F9] rounded-[10px] resize-none outline-none px-[15px] py-[17px] mr-5;
            :deep(.el-textarea__inner) {
                @apply text-sm p-0 bg-transparent resize-none outline-none border-none;
            }
        }
        .send_btn{
            @apply min-w-[86px] h-[54px] bg-[#4C5BDF] rounded-[10px] cursor-pointer;
            .el-button, .el-button.is-plain:focus, .el-button.is-plain:hover{
                background: transparent !important;
            }
        }
        
    }
}
</style>